//MS stops supporting IE in their apps in 2020
//https://techcommunity.microsoft.com/t5/microsoft-365-blog/microsoft-365-apps-say-farewell-to-internet-explorer-11-and/ba-p/1591666

// June 15, 2022 - EoL 
//https://docs.microsoft.com/en-us/lifecycle/faq/internet-explorer-microsoft-edge
import { useState } from "react";
import {
  Typography,
  Link,
  Alert, 
  AlertTitle,
} from "@mui/material";


export default function NoSupportForIE(props:{isIE:boolean}) {
  const [isOpen, setIsOpen] = useState(props.isIE);
  if(!isOpen) return(<></>)
  return (
    <div style={{zIndex:Number.MAX_SAFE_INTEGER, position:"absolute", width:"100%", padding:"100px",}} >
      <Alert severity="warning" onClose={() => {setIsOpen(false)}} style={{ borderStyle:"double",borderWidth:"8px"}}> 
          <AlertTitle>Internet Explorer Browser Not Supported</AlertTitle>   
          <Typography paragraph>
            Internet Explorer is not supported by VendPrime / VendSmart. While some parts of the application may work in the IE browser, CONA has no plans to fix issues that are specific to IE.
            <br />
            Please upgrade to a more modern web browser like <Link href="https://www.google.com/chrome/">Chrome</Link> or <Link href="https://www.mozilla.org/">Firefox</Link>.
            Microsoft itself has <Link href='https://techcommunity.microsoft.com/t5/microsoft-365-blog/microsoft-365-apps-say-farewell-to-internet-explorer-11-and/ba-p/1591666'>discontinued support</Link> for IE in 2020 for their apps.
            The Internet Explorer program will reach <Link href='https://docs.microsoft.com/en-us/lifecycle/faq/internet-explorer-microsoft-edge'>end of life in 2022</Link>.             
          </Typography>
      </Alert>
    </div>
  );
}